import React, { useCallback, useEffect, useState } from 'react';
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch,
  withRouter,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { HomeScreen } from '../home';
import PageNotFound from '../pageNotFound/PageNotFound';
import InsuranceNavigation from '../insurance/InsuranceNavigation';
import { FileClaimbotScreen } from '../claims/claimbot/FileClaimbotScreen';
import InboxAndDocsScreen from '../inboxAndDocs/InboxAndDocsScreen';
import { MyAccountNavigation } from '../myAccount/MyAccountNavigation';
import { NavigationMyPets } from '../myPets/NavigationMyPets';
import GenericError from '../genericError/GenericError';
import { FoundLostPet } from '../foundLostPet/FoundLostPet';
import { AcceptTermsOfServiceModal } from '../settings';

import * as routes from './routes.constants';
import Header from './Header';
import './SessionRouter.css';
import { useB2CInfo } from '../../hooks';
import { getData } from '../../services/api';
import { CUSTOMER_API_TOKEN } from '../../services/constants';
import { UrgentMessages } from '../common/UrgentMessages';
import { TermsOfUseScreen } from '../contentfulPages/TermsOfUseScreen';
import { PrivacyPolicyScreen } from '../contentfulPages/PrivacyPolicyScreen';
import { WelcomeScreen } from '../petDemographics';
import { usePetDemographics } from '../petDemographics/hooks';
import { SideAndBurgerMenu } from '../sideMenu/SideAndBurgerMenu';
import { DialogMessage } from '../common';

const SessionRouterApp = () => {
  const store = useSelector(({ common, session }) => ({ common, session }));
  const { isExpired } = store.session;
  const { showGenericError } = store.common;
  const { inWelcomeScreen, redirectionRoute } = usePetDemographics();

  const { getAllTokens } = useB2CInfo();
  const history = useHistory();
  const match = useRouteMatch();

  const [contactUsVisible, setContactUsVisible] = useState(false);
  const [modalAddPetVisible, setModalAddPetVisible] = useState(false);

  const toggleModalAddPetVisible = useCallback(() => {
    setModalAddPetVisible((prevShow) => !prevShow);
  }, []);

  useEffect(() => {
    const hasToken = getData(CUSTOMER_API_TOKEN);
    if (!hasToken) {
      getAllTokens();
    }
  }, [getAllTokens]);

  useEffect(() => {
    if (showGenericError) {
      history.push(routes.ERROR);
    }

    if (isExpired) {
      getAllTokens();
    }
  }, [showGenericError, isExpired, history, getAllTokens]);

  useEffect(() => {
    const to = sessionStorage.getItem('to');

    if (to) {
      sessionStorage.removeItem('to');

      history.push(to);
    }
  }, []);

  return (
    <Switch>
      <Route exact path={routes.TERMS_OF_USE}>
        <TermsOfUseScreen />
      </Route>

      <Route exact path={routes.PRIVACY_POLICY}>
        <PrivacyPolicyScreen />
      </Route>

      <Route path="*">
        <Header isBurgerMenuHidden={inWelcomeScreen} />

        <AcceptTermsOfServiceModal />

        <DialogMessage />

        <div className="Layout" id="layout">
          {!inWelcomeScreen && (
            <SideAndBurgerMenu
              contactUsVisible={contactUsVisible}
              modalAddPetVisible={modalAddPetVisible}
              setContactUsVisible={setContactUsVisible}
              toggleModalAddPetVisible={toggleModalAddPetVisible}
            />
          )}

          <div className="Main-content">
            <div className="Main-content">
              <div className="Content">
                <Switch>
                  <Route exact path={['/', routes.HOME]}>
                    <HomeScreen />
                  </Route>

                  <Route exact path={routes.WELCOME_DEMOGRAPHICS}>
                    <WelcomeScreen />
                  </Route>

                  <Route path={[routes.B2C_TOKEN_REGISTER]}>
                    <Redirect to={redirectionRoute} />
                  </Route>

                  <Route path={routes.INBOX_DOCS}>
                    <InboxAndDocsScreen />
                  </Route>

                  <Route path={routes.MY_ACCOUNT}>
                    <MyAccountNavigation />
                  </Route>

                  <Route exact path={routes.MY_PETS}>
                    <Redirect to="/insurance" />
                  </Route>

                  <Route path={[`${routes.MY_PETS}/:id`, routes.MY_PETS]}>
                    <NavigationMyPets
                      contactUsVisible={contactUsVisible}
                      setContactUsVisible={setContactUsVisible}
                    />
                  </Route>

                  <Route path={[routes.INSURANCE, routes.CHANGE_COVERAGE]}>
                    <InsuranceNavigation />
                  </Route>

                  <Route path={routes.CLAIMS}>
                    <InsuranceNavigation />
                  </Route>

                  <Route path={`${match.path}/details`}>
                    <InsuranceNavigation />
                  </Route>

                  <Route
                    path={[
                      // WIP: for conditions component qa testing
                      `${routes.FILE_CLAIMBOT}/:tempConditions`,
                      routes.FILE_CLAIMBOT,
                    ]}
                  >
                    <FileClaimbotScreen />
                  </Route>

                  {/* TODO uncomment when is ready to prod
                <Route path="/vets">
                  {comingSoon}
                </Route> */}

                  <Route path={routes.ERROR}>
                    <GenericError />
                  </Route>

                  <Route exact path={routes.FOUND_LOST_PET}>
                    <FoundLostPet />
                  </Route>

                  <Route path="*">
                    <PageNotFound />
                  </Route>
                </Switch>
              </div>
            </div>
          </div>
        </div>

        <UrgentMessages />
      </Route>
    </Switch>
  );
};

export default withRouter(SessionRouterApp);
